import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const CostallocationListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [costallocations, setCostallocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams) || '';

      if (query && query.toString().includes(',"multiSortMeta":[]')) {
        query = query.replace(',"multiSortMeta":[]', '')
      }

      const costItemFilter = (id && action === 'read')
        ? (query && query.includes('?') ? '&' : '?') + 'search[cost_item][operator]==&search[cost_item][value][]=' + id
        : '';

      apiCall('get', '/api/v2/cost-allocation' + query + costItemFilter)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setCostallocations(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const ratioBodyTemplate = (rowData) => {
    const total = Number(rowData?.cost_item?.amount ?? 0);
    const part = Number(rowData?.amount ?? 0);
    if (!total || total === 0) return '0%';
    return Math.round((part / total) * 100).toString() + '%';
  }

  const costSourceBodyTemplate = (rowData) => {
    const source = rowData?.cost_item?.source;
    return source ? t(`costSource${source}`) : '';
  }

  useEffect(() => {
    setLazyParams(prev => ({...prev, rows: rows}));
  }, [rows]);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderCostallocationList])

  return (
    <>
      <h4 className={"p-mt-0"}>{t('costAllocation')}</h4>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={costallocations} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="cost_type.name" header={t('columnCostType')} sortable></Column>
        <Column field="cost_center.name" header={t('columnCostCenter')} sortable></Column>
        <Column field="cost_item.source" header={t('columnCostSource')} body={costSourceBodyTemplate}></Column>
        <Column field="amount" header={t('columnAmount')} sortable className={"p-text-right"} body={(rowData) => {
          return (
            <>{rowData?.amount}</>
          )
        }}></Column>
        <Column header={t('columnCostRatio')} className={"p-text-right"} body={ratioBodyTemplate}></Column>

        {/* <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{rowData?.created_at ? window.App.formatDateValue(rowData.created_at) : ''}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{rowData?.updated_at ? window.App.formatDateValue(rowData.updated_at) : ''}</>
          )
        }}></Column> */}

      </DataTable>
    </>
  )
}
export default withTranslation('common')(CostallocationListComponent);
